import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@material-ui/core";
import React, { useState } from "react";
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  
const ConfirmModal = (
    {
        page_id,
        handleDelete,
        deleteSlot,
        confirmModal
    }
) => {
  
  return (
    <Dialog
      open={confirmModal}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleDelete} // Change this to handle modal close without deleting
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <DialogTitle id="confirm-dialog-title">
        {"Delete Page Confirmation"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          Are you sure you want to delete this page?.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDelete} color="secondary">
          Close
        </Button>
        <Button onClick={deleteSlot} color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
